import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../../../../shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface AccountsCsvImportStepHeaderProps {
  title: ReactNode;
  stepNumber: number;
  isDisabled?: boolean;
  description?: ReactNode;
}

/*
 * Style.
 */

const StyledStepHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

interface StyledTitleDivProps {
  $isDisabled: boolean;
}

const StyledTitleDiv = styled.div<StyledTitleDivProps>`
  font-size: 18px;
  line-height: 24px;
  font-weight: ${fontWeights.semibold};
  letter-spacing: -0.5px;
  color: ${(p) => (p.$isDisabled ? p.theme.greys.shade60 : p.theme.greys.shade90)};
`;

interface StyledNumberDivProps {
  $isDisabled: boolean;
}

const StyledNumberDiv = styled.div<StyledNumberDivProps>`
  height: 16px;
  width: 16px;
  font-size: 9px;
  line-height: 12px;
  font-weight: ${fontWeights.black};
  border-radius: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: ${(p) =>
    p.$isDisabled ? `1.5px solid ${p.theme.greys.shade60}` : `1px solid ${p.theme.palette.blue.shade40}`};
  background-color: ${(p) => (p.$isDisabled ? p.theme.greys.white : p.theme.palette.blue.shade40)};
  color: ${(p) => (p.$isDisabled ? p.theme.greys.shade60 : p.theme.greys.white)};
`;

const StyledDescriptionDiv = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.25px;
  color: ${(p) => p.theme.greys.shade80};
  max-width: 600px;
`;

/*
 * Component.
 */

export const AccountsCsvImportStepHeader: FC<AccountsCsvImportStepHeaderProps> = ({
  title,
  stepNumber,
  isDisabled,
  description,
}) => (
  <>
    <StyledStepHeaderDiv>
      <StyledNumberDiv $isDisabled={Boolean(isDisabled)}>{stepNumber}</StyledNumberDiv>
      <StyledTitleDiv $isDisabled={Boolean(isDisabled)}>{title}</StyledTitleDiv>
    </StyledStepHeaderDiv>
    {!isDisabled && description && <StyledDescriptionDiv>{description}</StyledDescriptionDiv>}
  </>
);
